import {
  FETCH_ADJUSTMENT_PERIODS,
  FETCH_ADJUSTMENT_PERIODS_SUCCESS,
  FETCH_ADJUSTMENT_PERIODS_FAILURE,
  SELECT_ADJUSTMENT_PERIOD,
  FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES,
  FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_SUCCESS,
  FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_FAILURE,
  FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES,
  FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_SUCCESS,
  FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_FAILURE,
  SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES,
  SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES_CONNECTION,
  SELECT_CONNECTION_FOR_BEGINNING_BALANCES,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_SUCCESS,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_FAILURE,
  FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE,
  FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_SUCCESS,
  FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_FAILURE,
  FETCH_BEGINNING_BALANCE_IMPORT_DATA_SUCCESS,
  UPLOAD_BEGINING_BALANCES_FILE,
  UPLOAD_BEGINING_BALANCES_FILE_SUCCESS,
  UPLOAD_BEGINING_BALANCES_FILE_FAILURE,
} from './types';
import initialState from './initialState';
import { YES_FLAG } from '../../../shared/constants';

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADJUSTMENT_PERIODS:
      return {
        ...state,
        adjustmentPeriodsLoading: true,
      };
    case FETCH_ADJUSTMENT_PERIODS_SUCCESS:
      return {
        ...state,
        adjustmentPeriods: action.adjustmentPeriods,
        adjustmentPeriodsLoading: false,
        adjustmentPeriod: action.adjustmentPeriods.find(period => period.currentPeriod === YES_FLAG).periodName,
      };
    case FETCH_ADJUSTMENT_PERIODS_FAILURE:
      return {
        ...state,
        adjustmentPeriodsLoading: false,
      };
    case SELECT_ADJUSTMENT_PERIOD:
      return {
        ...state,
        adjustmentPeriod: action.period,
      };
    case FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES:
      return {
        ...state,
        companyCodesLoading: true,
      };
    case FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_FAILURE:
      return {
        ...state,
        companyCodesLoading: false,
      };
    case FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_SUCCESS:
      return {
        ...state,
        companyCodes: action.companyCodes,
        companyCode: null,
        companyCodesLoading: false,
      };
    case SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES:
      return {
        ...state,
        companyCode: action.companyCode,
        connection: null,
        companyCodeForConnection: null,
      };
    case SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES_CONNECTION:
      return {
        ...state,
        companyCode: null,
        companyCodeForConnection: action.companyCode,
      };
    case FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES:
      return {
        ...state,
        connectionsLoading: true,
      };
    case FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_SUCCESS:
      return {
        ...state,
        connections: action.connections,
        connectionsLoading: false,
      };
    case FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_FAILURE:
      return {
        ...state,
        connectionsLoading: false,
      };
    case SELECT_CONNECTION_FOR_BEGINNING_BALANCES:
      return {
        ...state,
        connection: action.connection,
        companyCode: null,
        companyCodeForConnection: null,
      };
    case FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES:
      return {
        ...state,
        companyCodesForConnectionLoading: true,
      };
    case FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_SUCCESS:
      return {
        ...state,
        companyCodesForConnection: action.companyCodesForConnection,
        companyCodesForConnectionLoading: false,
      };
    case FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_FAILURE:
      return {
        ...state,
        companyCodesForConnection: null,
        companyCodesForConnectionLoading: false,
      };
    case FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE:
      return {
        ...state,
        beginningBalancesLoading: true,
      };
    case FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_SUCCESS:
      return {
        ...state,
        beginningBalances: action.beginningBalances,
        beginningBalancesLoading: false,
        validationSummary: action.validationSummary,
        ignoredCompanyCodes: action.ignoredCompanyCodes,
      };
    case FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_FAILURE:
      return {
        ...state,
        beginningBalancesLoading: false,
      };
    case FETCH_BEGINNING_BALANCE_IMPORT_DATA_SUCCESS:
      return {
        ...state,
        importData: action.importData,
        ignoredCompanyCodes: action.ignoredCompanyCodes,
      };
    case UPLOAD_BEGINING_BALANCES_FILE:
      return {
        ...state,
        isUploadingBeginningBalances: true,
      };
    case UPLOAD_BEGINING_BALANCES_FILE_SUCCESS:
    case UPLOAD_BEGINING_BALANCES_FILE_FAILURE:
      return {
        ...state,
        isUploadingBeginningBalances: false,
      };
    default:
      return state;
  }
}
